<template>
    <div class="lo index">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.index {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        flex-shrink: 0;

        @include media('mobile') {
            flex-direction: column;
        }
    }
</style>
